import { render, staticRenderFns } from "./CenterContent.vue?vue&type=template&id=43bb9c1e&"
import script from "./CenterContent.vue?vue&type=script&lang=js&"
export * from "./CenterContent.vue?vue&type=script&lang=js&"
import style0 from "./CenterContent.vue?vue&type=style&index=0&id=43bb9c1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports